/**
 * Прокручивает главную страницу к блоку из query-параметра `scrollTo`.
 */
export const useScrollToBlock = () => {
  const route = useRoute()
  const router = useRouter()

  const onScrollToBlock = () => {
    const scrollName = route.query?.scrollTo

    if (scrollName) {
      router.replace({ query: {} })

      setTimeout(() => {
        document
          .querySelector<HTMLElement>(`#${scrollName as string}`)
          ?.scrollIntoView({ behavior: 'smooth', block: 'center' })
      }, 200)
    }
  }

  onMounted(() => {
    onScrollToBlock()
  })
}
